function insertScriptTag(scriptId, link, async = false) {
  (((d, s, id) => {
    const fjs = d.getElementsByTagName(s)[0];
    if (d.getElementById(id)) { return; }
    const js = d.createElement(s); js.id = id;
    js.src = link;
    js.async = async;
    fjs.parentNode.insertBefore(js, fjs);
  })(document, 'script', scriptId));
}

function injectScript(instance, link, async = false) {
  let ctr = 0;

  insertScriptTag(`${instance}-script`, link, async);

  return new Promise((resolve, reject) => {
    const handle = window.setInterval(() => {
      if (window[instance]) {
        resolve();
        clearInterval(handle);
      }
      ctr += 1;
      if (ctr > 1000) {
        reject(Error(`Unable to load ${instance}`));
        clearInterval(handle);
      }
    }, 5);
  });
}

export default injectScript;
export { insertScriptTag, injectScript };
